export enum AIAssistantAnswerStatusEnum {
  PENDING = 'pending',
  STARTED = 'started',
  FINISHED = 'finished',
  FAILED = 'failed',
  EXPIRED = 'expired',
  MINIMIZED = 'minimized',
  RESTORED = 'restored',
}
